import React, { useState, Key, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IDetailList, ISaleSoFields, ISaleSoDetail, ISaleSoSearch, Ids, Detailed, ISaleSoSettleAndWhConfirm } from "../../saleSoTypes"
import { saleSoService } from "../../saleSoService"
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
// import { IMaterialBase, IMaterialDetail, materialService } from "../../../../../base/material/materialService"
import { IStockStatisticFields, IStockStatisticSearch, IStockStatisticDetail, stockStatisticService } from "../../../../../stock/statistic/stockStatisticService"
import { IShelfFileds } from "../../../../../base/warehouse/warehouseService"
import { transPgToPagination, switchNum1 } from "@/utils/utils";
import { useDictModel } from "../../../../../base/dict/dictModel";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { globalPrompt } from "@/components/message";
import { AmazonOutlined } from "@ant-design/icons";
import { formatNum, formatInt, formatDiscount } from "@/utils/utils";
import { convertRes2Blob } from "@/utils/exportFile";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useLockFn } from "ahooks";
export type ISaleSoDescType = {
    numAll: number,
    itemNumAll: number,
    totalAll: number,
    saleAll: number,
    discountAll: number,
    receivableAll: number
    [key: string]: any
}
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends IStockStatisticDetail {
    num: number
}
export const useSaleSoDetailModel = createModel(function () {
    const { getTreeNodeName } = useDictModel();
    const { supplieAllList, CustomerData, user, setLocale } = useGlobalModel()
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const [addModalVisible, setAddModalVisible] = useState<boolean>(false)  //新增商品弹框
    const initDesc = {
        numAll: 0,  //数量
        itemNumAll: 0, //项数
        saleAll: 0,//销售金额
        discountAll: 0,//优惠金额
        receivableAll: 0,//实收金额
        taxationAll: 0, //税费
        totalAll: 0 //总计
    }
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initSearchParam: IStockStatisticSearch = {};

    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<ISaleSoFields>({ favorableAmount: 0, discountRate: 100 })
    //新增详情列表
    const [detailAddList, setDetailAddList] = useState<IDetailList[]>([])
    //新增详情列表选中行
    const [detaiAddDataRowKeys, setDetaiAddDataRowKeys] = useState<Key[]>([]);
    const [detaiAddDataRow, setDetaiAddDataRow] = useState<IDetailList[]>([]);
    const [addDesc, setAddDesc] = useState<ISaleSoDescType>(initDesc)

    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<ISaleSoFields>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<ISaleSoDescType>(initDesc)

    //详情数据
    //详情列表参数
    const [detailDataSource, setDetailDataSource] = useState<IDetailList[]>([]);
    //详情表格选中行
    const [detailDataRowKeys, setDetailDataRowKeys] = useState<Key[]>([]);
    const [detailDataRow, setDetailDataRow] = useState<IDetailList[]>([]);
    const [detailEditForm, setDetailEditForm] = useState<ISaleSoFields>({})
    const [editDesc, setEditDesc] = useState<ISaleSoDescType>(initDesc)
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<IShelfFileds[]>([])
    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IStockStatisticSearch>(initSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([]);

    //设置底部总数展示（查看|编辑|查看） //金额还没有详细算

    // numAll: 0,  //数量
    // itemNumAll: 0, //项数
    // saleAll: 0,//销售金额
    // discountAll: 0,//优惠金额
    // receivableAll: 0,//实收金额
    // taxationAll: 0, //税费
    // totalAll: 0 //总计
    useEffect(() => {
        let newDesc: ISaleSoDescType = { ...initDesc };
        detailDataSource && detailDataSource.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.saleAll += Number(item.notAmount)
            newDesc.discountAll += Number(item.notAmount) - Number(item.amount);
            newDesc.receivableAll += Number(item.amount)
        });
        newDesc.itemNumAll = detailDataSource && detailDataSource.length


        if ("favorableAmount" in detailEditForm) {
            newDesc.discountAll = newDesc.discountAll + Number(detailEditForm.favorableAmount)
            newDesc.receivableAll = (newDesc.receivableAll - Number(detailEditForm.favorableAmount))
        }
        newDesc.taxationAll = (newDesc.receivableAll) * 0.15
        newDesc.receivableAll = (newDesc.receivableAll) * 1.15
        setEditDesc(newDesc);
    }, [detailDataSource, detailEditForm])

    useEffect(() => {
        let newDesc: ISaleSoDescType = { ...initDesc };
        detailAddList && detailAddList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.saleAll += Number(item.notAmount)
            newDesc.discountAll += Number(item.notAmount) - Number(item.amount);
            // newDesc.receivableAll += Number(item.amount)
            newDesc.receivableAll += Number(item.amount)
        });
        newDesc.itemNumAll = detailAddList && detailAddList.length;


        if ("favorableAmount" in detailAddForm) {
            newDesc.discountAll = newDesc.discountAll + Number(detailAddForm.favorableAmount)
            newDesc.receivableAll = (newDesc.receivableAll - Number(detailAddForm.favorableAmount))
        }
        newDesc.taxationAll = (newDesc.receivableAll) * 0.15
        newDesc.receivableAll = (newDesc.receivableAll) * 1.15
        setAddDesc(newDesc);
    }, [detailAddList, detailAddForm])

    useEffect(() => {
        let newDesc: ISaleSoDescType = { ...initDesc };
        detailLookList && detailLookList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.saleAll += Number(item.notAmount)
            newDesc.discountAll += Number(item.notAmount) - Number(item.amount);
            newDesc.receivableAll += Number(item.amount)
        });

        newDesc.itemNumAll = detailLookList && detailLookList.length
        if ("favorableAmount" in detailLookForm) {
            newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount)
            newDesc.receivableAll = (newDesc.receivableAll - Number(detailLookForm.favorableAmount))
        }
        newDesc.taxationAll = (newDesc.receivableAll) * 0.15
        newDesc.receivableAll = (newDesc.receivableAll) * 1.15
        setLookDesc(newDesc);
    }, [detailLookList, detailLookForm])
    //新增表单缓存
    const updateAddFormVal = (val: ISaleSoFields) => {
        let newVal = val;
        if ("customerCode" in val) {
            console.log(getFindItem(val.customerCode as string, CustomerData))
            const { contact, phone, address, typeName, code, name, categoryCode } = getFindItem(val.customerCode as string, CustomerData)
            newVal = { ...val, contact, phone, address, customerTypeCode: categoryCode, customerTypeName: typeName, customerName: name }
        }
        if ("discountRate" in val) {
            let discountRate = +switchNum1(val.discountRate, "")
            newVal = { ...val, discountRate }
            // detailAddList, setDetailAddList
            setDetailAddList(detailAddList.map(item => ({
                ...item,
                discountRate: discountRate,
                amount: +(Number(item.notAmount) * discountRate / 100).toFixed(2)
            })))
        }
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: ISaleSoFields) => {
        let newVal = val;
        if ("customerCode" in val) {
            const { contact, phone, address, typeName, code, name, categoryCode } = getFindItem(val.customerCode as string, CustomerData)
            newVal = { ...val, contact, phone, address, customerTypeCode: categoryCode, customerTypeName: typeName, customerName: name }
        }
        if ("discountRate" in val) {
            let discountRate = +switchNum1(val.discountRate, "")
            newVal = { ...val, discountRate }
            // detailDataSource, setDetailDataSource
            setDetailDataSource(detailDataSource.map(item => ({
                ...item,
                discountRate: discountRate,
                amount: +(Number(item.notAmount) * discountRate / 100).toFixed(2)
            })))
        }
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await saleSoService.one(id);
        const { details, ...from } = retData
        let newDetails = details?.map(item => {
            return {
                ...item,
                notAmount: (Number(item.num) * Number(item.price)).toFixed(2),
                detailsId: item.id
            }
        })
        if (retData && pattern == "edit") {
            setDetailDataSource(newDetails as IDetailList[] ?? [])
            setDetailEditForm(from)
        } else if (retData && pattern == "look") {
            setDetailLookForm(from);
            setDetailLookList(newDetails as IDetailList[] ?? [])

        }
    }
    //关闭弹框
    const resetWorkloadData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IStockStatisticSearch = searchWorkData) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await stockStatisticService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            let { lateSalePrice, retailPrice } = item
            return {
                ...item,
                num: 1,
                lateSalePrice: lateSalePrice || retailPrice,
                amount: (lateSalePrice || retailPrice) * 1,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
    }
    // 筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IDetailList[], detailList: IDetailList[], mode: string) => {
        console.log(modelList, detailList)
        const repetition: string[] = [];
        const newDetailData: IDetailList[] = []
        modelList.forEach(Item => {
            let isSelect = detailList && detailList.find(item => item.materialCode === Item.materialCode);
            if (isSelect === undefined) {
                newDetailData.push({
                    ...Item,
                    notAmount: Item.amount,
                    materialNameEn: Item.nameEn,
                    discountRate: mode == "add" ? detailAddForm?.discountRate : detailEditForm?.discountRate,
                    amount: formatNum(Number(Item.amount) * Number(mode == "add" ? detailAddForm?.discountRate : detailEditForm?.discountRate) / 100),
                    detailsId: Item.id,
                    price: Item.lateSalePrice ?? Item.price,
                    id: "",
                });
            } else {
                repetition.push(Item.materialName as string);
            }
        })
        return { newDetailData, repetition }
    }
    //添加到详情列表
    const transformsToDetailList = async (mode: string) => {
        //添加列表
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailAddList, mode)
            setDetailAddList([...detailAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });
        } else if (mode == "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailDataSource, mode)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });
        }
    }
    //删除详情列表数据
    const detailDetailList = async (mode: string) => {
        if (mode == "add") {
            const filterDetailList = detailAddList.filter(el => !!!detaiAddDataRowKeys.find(ele => ele === el.detailsId))
            setDetailAddList(filterDetailList)
            // globalPrompt("message", { text: `删除成功`, type: "success" });
            globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
        } else if (mode == "edit") {
            const backendDetailList: any = detailDataRow.reduce((all, next) => {  //前端页面维护的需要删除的id
                if (next.id) {
                    all.push({ id: next.id });
                }
                return all;
            }, []);

            //删除详情列表调用的方法
            const deleteData = () => {
                const filterDetailList = detailDataSource.filter(el => !!!detailDataRowKeys.find(ele => ele === el.detailsId))
                console.log(filterDetailList)
                setDetailDataSource(filterDetailList)
                // globalPrompt("message", { text: `删除成功`, type: "success" });
                globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });

            }

            if (backendDetailList.length > 0) {
                await saleSoService.materialDelete({ ids: backendDetailList }).then(res => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        // globalPrompt("message", { text: `删除失败`, type: "success" });
                        globalPrompt("message", { text: Locale["Unsuccessfully deleted"], type: "success" });
                    }
                })
            } else {
                deleteData()
            }


        }
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: ISaleSoDetail) => {
        let newParams = {
            ...params,
            createUser: user.username,
            customerName: getFindItem(params.customerCode as string, CustomerData).name,
            customerTypeName: getTreeNodeName(params.customerTypeCode as string),
            details: detailAddList
        }
        let { retData } = await saleSoService.insert(newParams);
        return retData;
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: ISaleSoDetail) => {
        let newParams = {
            ...params,
            updateUser: user.username,
            customerName: getFindItem(params.customerCode as string, CustomerData).name,
            customerTypeName: getTreeNodeName(params.customerTypeCode as string),
            details: detailDataSource
        }
        let { retData } = await saleSoService.update(newParams);
        return retData;
    })
    //结算操作
    const Settle = async (data: ISaleSoDetail) => {
        const params = {
            reckoner: user.username,
            ...data
        }
        let { retData } = await saleSoService.settl(params);
        return retData
    }
    //出库操作
    const WhConfirm = async (data: ISaleSoDetail) => {
        const params = {
            storekeeper: user.username,
            ...data
        }
        let { retData } = await saleSoService.warehousing(params);
        return retData
    }
    //下载模板 
    const onExport = async () => {
        let result = await saleSoService.downloadTpl();
        convertRes2Blob(result);

    }
    //关闭页签清不同状态缓存
    const resetCatch = async (type: string) => {
        console.log(type)
        if (type == "add") {
            setDetailAddList([]);
            setDetailAddForm({})
        } else if (type == "edit") {
            setDetailEditForm({});
            setDetailDataSource([]);
        }
    }
    const resetAddCatch = async (type: string) => {
        setDetailAddList([]);
        setDetailAddForm({ favorableAmount: 0, discountRate: 100 })
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailDataSource([]);
    }
    //商品进销存明细
    const [materialHistoryModel, setMaterialHistoryModel] = useState<boolean>(false); //商品进销存明细弹框 
    const [materialHistoryRow, setMaterialHistoryRow] = useState<IDetailList>({}); //商品进销存明细弹框 
    const [materialHistoryType, setMaterialHistoryType] = useState<string>("trade-type.purchase")//trade-type.sale-order 查询历史状态
    return {
        addModalVisible,
        addDataSource,
        workDataSource,
        searchWorkData,
        workPgCfg,
        detailDataSource,
        detailDataRowKeys,
        detailDataRow,
        detailAddList,
        detaiAddDataRowKeys,
        detaiAddDataRow,
        detailLookForm,
        detailLookList,
        detailEditForm,
        detailAddForm,
        addDesc,
        lookDesc,
        editDesc,
        shelfAllList,
        setAddModalVisible,
        setAddDesc,
        setLookDesc,
        setEditDesc,
        setDetailAddForm,
        setDetaiAddDataRowKeys,
        setDetailAddList,
        setDetailDataRow,
        setDetailDataRowKeys,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        setDetaiAddDataRow,
        setDetailLookForm,
        setDetailLookList,
        setDetailDataSource,
        setDetailEditForm,
        setShelfAllList,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetWorkloadData,
        workloadData,
        insertDetail,
        editDetail,
        Settle,
        WhConfirm,
        transformsToDetailList,
        detailDetailList,
        resetCatch,
        modelScreenMethod,
        resetAddCatch,
        resetEditCatch,
        onExport,
        materialHistoryModel,
        setMaterialHistoryModel,
        materialHistoryRow,
        setMaterialHistoryRow,
        materialHistoryType,
        setMaterialHistoryType,
    }
});